import { useReq } from '@/utils/request/useReq'

const exploreUrl = '/account/bifund/explore'
const explore = (params = {}, options = {}) =>
  useReq(exploreUrl, { method: 'GET', params, auth: false }, options)

const assetPageUrl = '/account/bifund/asset/page'
const assetPage = (params = {}, options = {}) =>
  useReq(assetPageUrl, { method: 'GET', params, auth: false }, options)

const assetDetailUrl = '/account/bifund/asset/detail'
const assetDetail = (params = {}, options = {}) =>
  useReq(assetDetailUrl, { method: 'GET', params, auth: false }, options)

const assetKlineUrl = '/account/bifund/asset/kline'
const assetKline = (params = {}, options = {}) =>
  useReq(assetKlineUrl, { method: 'GET', params, auth: false }, options)

const positionPageUrl = '/account/bifund/position/page'
const positionPage = (params = {}, options = {}) =>
  useReq(positionPageUrl, { method: 'GET', params }, options)

const recordPageUrl = '/account/bifund/record/page'
const recordPage = (params = {}, options = {}) =>
  useReq(recordPageUrl, { method: 'GET', params }, options)

const subscribeUrl = '/account/bifund/subscribe'
const subscribe = (params = {}, options = {}) =>
  useReq(subscribeUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const ransomUrl = '/account/bifund/ransom'
const ransom = (params = {}, options = {}) =>
  useReq(ransomUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const needLoginUrl = [positionPageUrl, recordPageUrl, subscribeUrl, ransomUrl]

export const bifundApi = {
  explore,
  assetPage,
  assetDetail,
  assetKline,
  positionPage,
  recordPage,
  subscribe,
  ransom,
  needLoginUrl,
}

export default bifundApi
